import { useEffect } from 'react';
import { resolveFavicons } from 'utils';
import { URL_APP_TYPE } from 'consts';

import { getAppType } from '../../utils';

const useFavicon = (): void => {
    useEffect(() => {
        const appType = getAppType();
        const map = Object.entries(URL_APP_TYPE).reduce<Record<string, string>>(
            (acc, [key, value]) => ({ ...acc, [value]: key }),
            {},
        );

        resolveFavicons(map[appType] as Parameters<typeof resolveFavicons>[0]);
    }, []);
};

export default useFavicon;
